import { logWrapper } from '../../utils';
import { resolveReferences } from '../../utils';
import CryptoJS from 'crypto-js';

export default {
  userCrudService: [
    'runtimeConstant',
    '$http',
    '$q',
    '$filter',
    '$state',
    'webApiSettings',
    'authService',
    'userModel',
    'companyModel',
    'groupModel',
    'featureModel',
    'EAdminFeatures',
    function (
      runtimeConstant,
      $http,
      $q,
      $filter,
      $state,
      webApiSettings,
      authService,
      User,
      Company,
      Group,
      Feature,
      EAdminFeatures
    ) {
      'use strict';

      function handleError(err, status) {
        if (status === 404 || status === -1) {
          return {
            status_code: status,
            title: $filter('translate')('SERVER OFFLINE'),
            text: $filter('translate')('SERVER OFFLINE MESSAGE'),
          };
        }

        if (status === 400 && err.ModelState) {
          return {
            title: $filter('translate')('ERROR'),
            text: $filter('translate')('VERIFY FIELD ERRORS'),
            modelState: err.ModelState,
          };
        }

        return {
          title: $filter('translate')('ERROR'),
          text: $filter('translate')('ERROR SAVE USER'),
        };
      }

      function sortColumns() {
        return [
          {
            column: 'name',
            title: 'NAME',
            type: 'text',
            sortOrder: 'asc',
          },
          {
            column: 'email',
            title: 'EMAIL',
            type: 'text',
            sortOrder: 'asc',
          },
          {
            column: 'registrationDate',
            title: 'REGISTRATION DATE',
            type: 'date',
            sortOrder: 'desc'
          },
        ];
      }

      function extraActions() {
        var deferred = $q.defer();

        deferred.resolve([
          {
            action: 'groups',
            title: 'GROUPS',
            icon: 'md md-group',
            execute: function (item) {
              $state.go('modules.security.users-edit', {
                id: item.id,
                tab: 'grupos',
              });
            },
          },
          {
            action: 'permissions',
            title: 'PERMISSIONS',
            icon: 'md md-beenhere',
            execute: function (item) {
              $state.go('modules.security.users-edit', {
                id: item.id,
                tab: 'permissoes',
              });
            },
          },
        ]);

        return deferred.promise;
      }

      function listFilters() {
        var deferred = $q.defer();
        var filters = [
          {
            filter: 'COMPANY USERS',
            title: 'COMPANY USERS FILTER',
            selected: true,
          },
          {
            filter: 'ALL USERS',
            title: 'ALL USERS FILTER',
          },
        ];

        if (authService.user === undefined) {
          authService.loadUser().then(function (user) {
            if (user.isSysAdmin) {
              deferred.resolve(filters);
            }
            deferred.resolve(null);
          });
        } else {
          if (authService.isSysAdmin()) {
            deferred.resolve(filters);
          }
          deferred.resolve(null);
        }

        return deferred.promise;
      }

      function hasPermission() {
        var user = authService.user;
        if (user && user.email) {
          return (
            authService.isAdmin() ||
            (user.adminFeatures &&
              user.adminFeatures.filter(function (af) {
                return af.IdAdminFeature === EAdminFeatures.ManageUsers;
              }).length > 0)
          );
        }
        return false;
      }

      function allByCompany(idFolder) {
        var deferred = $q.defer();

        if (idFolder === undefined || idFolder === null || idFolder === 0) {
          deferred.resolve([]);
          return deferred.promise;
        }

        $http
          .get(
            `${webApiSettings.apiServiceBaseUri}users/allByCompany/${idFolder}`
          )
          .then((res) => {
            var data = res.data;
            var result = [];

            for (var i = 0; i < data.length; i++) {
              result.push(new User(data[i]));
            }

            deferred.resolve(result);
          })
          .catch((err) => {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function list(filter) {
        var deferred = $q.defer();

        var url = 'users';

        if (
          filter === undefined ||
          filter === null ||
          filter.filter === 'COMPANY USERS'
        ) {
          url = 'users/byCompany';
        }

        $http.get(webApiSettings.apiServiceBaseUri + url).then(
          function (res) {
            var data = res.data;
            var result = [];

            for (var i = 0; i < data.length; i++) {
              result.push(new User(data[i]));
            }

            deferred.resolve(result);
          },
          function (err) {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          }
        );

        return deferred.promise;
      }

      function getCompanies(user) {
        if (authService.isSysAdmin()) {
          var companies = user.allCompanies.filter(function (c) {
            return c.selected;
          });

          var userCompanies = [];
          for (var i = 0, length = companies.length; i < length; i++) {
            var uc = {
              IdUser: user.id,
              IdCompany: companies[i].id,
              IsAdmin: companies[i].isAdmin,
            };
            userCompanies.push(uc);
          }
          user.companies = userCompanies;
        } else {
          if (!user.id) {
            user.companies = [
              {
                IdUser: user.id,
                IdCompany: authService.user.userPreferences.IdLastCompany,
              },
            ];
          }
        }
      }

      function getGroups(user) {
        if (user.allGroups) {
          user.groups = [];
          var groups = user.allGroups.filter(function (c) {
            return c.selected;
          });

          for (var j = 0, l = groups.length; j < l; j++) {
            user.groups.push({
              IdUser: user.id,
              IdGroup: groups[j].id,
            });
          }
        }
      }

      function getAdminFeatures(user) {
        if (user.allAdminFeatures) {
          user.adminFeatures = [];
          var features = user.allAdminFeatures.filter(function (f) {
            return f.selected;
          });

          for (
            var k = 0, lengthFeatures = features.length;
            k < lengthFeatures;
            k++
          ) {
            user.adminFeatures.push({
              IdAdminFeature: features[k].id,
              IdUser: user.id,
            });
          }
        }
      }

      function save(user) {
        var deferred = $q.defer();
        getCompanies(user);
        getGroups(user);
        getAdminFeatures(user);

        var confirmPass = '';
        if (user.isPassChanged) {
          var pass = CryptoJS.MD5(user.pass).toString();
          user.pass = pass;
          confirmPass = CryptoJS.MD5(user.confirmPass).toString();
        }
        user.confirmPass = '';

        if (user.id === 0) {
          $http.post(webApiSettings.apiServiceBaseUri + 'users', user).then(
            function (result) {
              var data = result.data;
              deferred.resolve(data);
            },
            function (err) {
              user.confirmPass = confirmPass;
              user.isPassChanged = false;
              var error = handleError(err.data, err.status);
              deferred.reject(error);
            }
          );
        } else {
          $http.put(webApiSettings.apiServiceBaseUri + 'users', user).then(
            function (result) {
              var data = result.data;
              deferred.resolve(data);
            },
            function (err) {
              user.confirmPass = confirmPass;
              user.isPassChanged = false;
              var error = handleError(err.data, err.status);
              deferred.reject(error);
            }
          );
        }

        return deferred.promise;
      }

      function selectCompanies(user, companies) {
        user.userCompanies.forEach(function (c) {
          var fs = companies.filter(function (f) {
            return f.id === c.IdCompany;
          });
          if (fs.length > 0) {
            fs[0].selected = true;
            fs[0].isAdmin = c.IsAdmin;
          }
        });
        user.allCompanies = companies;
      }

      function selectGroups(user, groups) {
        user.groups.forEach(function (g) {
          var fs = groups.filter(function (f) {
            return f.id === g.IdGroup;
          });
          fs[0].selected = true;
        });
        user.allGroups = groups;
      }

      function load(id) {
        var deferred = $q.defer();

        var user = new User();
        var companies = null;
        var companiesDone = false;

        $http
          .get(webApiSettings.apiServiceBaseUri + 'companies/userCrud', {
            ignoreLoadingBar: true,
          })
          .then(
            (result) => {
              var data = result.data;
              companies = [];
              data = resolveReferences(data);
              data.forEach(function (d) {
                var company = new Company(d);
                if (
                  !id &&
                  !authService.isSysAdmin() &&
                  authService.getLoggedCompany().IdCompany === company.id
                ) {
                  company.selected = true;
                }
                companies.push(company);
              });

              if (id && user.id !== 0 && !companiesDone) {
                selectCompanies(user, companies);
                companiesDone = true;
                deferred.resolve(user);
              } else if (!id && !companiesDone) {
                user.allCompanies = companies;
                companiesDone = true;
                deferred.resolve(user);
              }
            },
            function (err) {
              deferred.reject({
                error: err.data,
                status: err.status,
              });
            }
          );

        if (id) {
          $http
            .get(
              webApiSettings.apiServiceBaseUri +
                'users/withCompanies/' +
                parseInt(id, 10),
              {
                ignoreLoadingBar: true,
              }
            )
            .then(
              (result) => {
                var data = result.data;
                data = resolveReferences(data);
                user = new User(data);

                if (companies !== null && !companiesDone) {
                  selectCompanies(user, companies);
                  companiesDone = true;
                  deferred.resolve(user);
                }
              },
              function (err) {
                deferred.reject({
                  error: err.data,
                  status: err.status,
                });
              }
            );
        } else {
          deferred.resolve(user);
        }

        return deferred.promise;
      }

      function loadGroups(currentItem) {
        currentItem.allGroups = [];
        var deferred = $q.defer();

        var userGroups = null;
        var groups = null;
        var groupsDone = false;

        if (currentItem && currentItem.id !== 0) {
          $http
            .get(
              webApiSettings.apiServiceBaseUri +
                'users/groupsByCompany/' +
                currentItem.id,
              {
                ignoreLoadingBar: true,
              }
            )
            .then(
              function (result) {
                var data = result.data;
                userGroups = [];
                data = resolveReferences(data);

                for (var i = 0, length = data.length; i < length; i++) {
                  userGroups.push(data[i]);
                }

                currentItem.groups = userGroups;

                if (groups !== null && !groupsDone) {
                  selectGroups(currentItem, groups);
                  groupsDone = true;
                  deferred.resolve(true);
                }
              },
              function (err) {
                deferred.reject({
                  error: err.data,
                  status: err.status,
                });
              }
            );
        } else {
          userGroups = [];
          currentItem.groups = [];
        }

        $http
          .get(webApiSettings.apiServiceBaseUri + 'groups', {
            ignoreLoadingBar: true,
          })
          .then(
            function (result) {
              var data = result.data;
              groups = [];
              data = resolveReferences(data);

              for (var i = 0, length = data.length; i < length; i++) {
                groups.push(new Group(data[i]));
              }

              if (userGroups !== null && !groupsDone) {
                selectGroups(currentItem, groups);
                groupsDone = true;
                deferred.resolve(true);
              }
            },
            function (err) {
              deferred.reject({
                error: err.data,
                status: err.status,
              });
            }
          );

        return deferred.promise;
      }

      function loadAdminFeatures(currentItem) {
        var deferred = $q.defer();

        $http
          .get(webApiSettings.apiServiceBaseUri + 'users/features', {
            ignoreLoadingBar: true,
          })
          .then(
            function (result) {
              var data = result.data;

              var features = data.map((f) => {
                var feature = new Feature(f, true);
                feature.selected = currentItem.adminFeatures.some(
                  (af) => af.IdAdminFeature === feature.id
                );
                return feature;
              });

              currentItem.allAdminFeatures = features;
              deferred.resolve(true);
            },
            function (err) {
              deferred.reject(err.data);
            }
          );

        return deferred.promise;
      }

      function loadData(tab, currentItem) {
        if (tab === 'grupos') {
          return loadGroups(currentItem);
        } else if (tab === 'permissoes') {
          return loadAdminFeatures(currentItem);
        }
      }

      function _delete(itens) {
        var deferred = $q.defer();

        var url = 'users/removelist/';
        var ids = [];
        for (var j = 0; j < itens.length; j++) {
          ids.push(itens[j].id);
        }

        $http.post(webApiSettings.apiServiceBaseUri + url, ids).then(
          function () {
            deferred.resolve(true);
          },
          function (err) {
            if (err.data.ModelState) {
              deferred.reject({
                title: $filter('translate')('ERROR ON DELETE USER'),
                text: err.data.ModelState['userLoggedCantBeDeleted'][0],
              });
            } else {
              deferred.reject(handleError(err.data, err.status));
            }
          }
        );

        return deferred.promise;
      }

      function updateIntegrationFolder(idFolderIntegration) {
        var deferred = $q.defer();
        $http
          .put(
            `${webApiSettings.apiServiceBaseUri}users/docusignintegration/${idFolderIntegration}`
          )
          .then((result) => {
            deferred.resolve(result);
          })
          .catch((err) => {
            deferred.reject(handleError(err.data, err.status));
          });

        return deferred.promise;
      }

      function updateTimeCheck(id, startHour, endHour) {
        var deferred = $q.defer();
        $http
          .post(
            `${webApiSettings.apiServiceBaseUri}users/timecheck/${id}/${startHour}/${endHour}`,
            {
              ignoreLoadingBar: true,
            }
          )
          .then((result) => {
            deferred.resolve(result);
          })
          .catch((err) => {
            deferred.reject(handleError(err.data, err.status));
          });

        return deferred.promise;
      }

      function deleteTimeCheck(id) {
        var deferred = $q.defer();
        $http
          .delete(`${webApiSettings.apiServiceBaseUri}users/timecheck/${id}`)
          .then(function (result) {
            deferred.resolve(result);
          })
          .catch((err) => {
            deferred.reject(handleError(err.data, err.status));
          });

        return deferred.promise;
      }

      function run() {
        try {
          var userCrudFactory = {};

          userCrudFactory.sortColumns = logWrapper(
            sortColumns,
            runtimeConstant.isDebugServicesInternals
          );
          userCrudFactory.extraActions = logWrapper(
            extraActions,
            runtimeConstant.isDebugServicesInternals
          );
          userCrudFactory.listFilters = logWrapper(
            listFilters,
            runtimeConstant.isDebugServicesInternals
          );
          userCrudFactory.list = logWrapper(
            list,
            runtimeConstant.isDebugServicesInternals
          );
          userCrudFactory.save = logWrapper(
            save,
            runtimeConstant.isDebugServicesInternals
          );
          userCrudFactory.delete = logWrapper(
            _delete,
            runtimeConstant.isDebugServicesInternals
          );
          userCrudFactory.load = logWrapper(
            load,
            runtimeConstant.isDebugServicesInternals
          );
          userCrudFactory.loadData = logWrapper(
            loadData,
            runtimeConstant.isDebugServicesInternals
          );
          userCrudFactory.hasPermission = logWrapper(
            hasPermission,
            runtimeConstant.isDebugServicesInternals
          );
          userCrudFactory.allByCompany = logWrapper(
            allByCompany,
            runtimeConstant.isDebugServicesInternals
          );
          userCrudFactory.updateIntegrationFolder = logWrapper(
            updateIntegrationFolder,
            runtimeConstant.isDebugServicesInternals
          );
          userCrudFactory.updateTimeCheck = logWrapper(
            updateTimeCheck,
            runtimeConstant.isDebugServicesInternals
          );
          userCrudFactory.deleteTimeCheck = logWrapper(
            deleteTimeCheck,
            runtimeConstant.isDebugServicesInternals
          );

          return userCrudFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
